/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { ErrorMessage } from "formik";
import { aboutPracticeType, iFee, iPractitionerProfile } from "ps-shared";
import FormikSwitch from "src/components/Forms/FormikSwitch";
import FormikMultiSelect, { SelectOption } from "src/components/Forms/FormikMultiSelect";
import { FormikMultiCreateSelect } from "src/components/Forms/FormikMultiCreateSelect";
import FormikDatetime from "src/components/Forms/FormikDatetime";
import paymentList from "ps-shared/models/forms/payment.json";
import specialtyList from "ps-shared/models/forms/specialties.json";
import serviceList from "ps-shared/models/forms/services.json";
import populationList from "ps-shared/models/forms/providerPopulation.json";
import insuranceList from "ps-shared/models/forms/insurance.json";
import substanceList from "ps-shared/models/forms/substances.json";
import FormikMultiAddress, { ValidationFuncResult } from "src/components/Forms/FormikMultiAddress";
import { RangeSliderValue, FormikMoneyRangeSlider } from "src/components/Forms/FormikMoneyRangeSlider";
import commonCurrencies from "ps-shared/models/forms/commonCurrencies.json";
import Switch from "react-bootstrap-switch";
// import google maps places script
import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";

interface AboutPracticeProps {
  values: aboutPracticeType;
  profile: iPractitionerProfile;
}

interface AboutPracticeState {
  paymentOptions: SelectOption[];
  specialties: SelectOption[];
  services: SelectOption[];
  population: SelectOption[];
  insurance: SelectOption[];
  substance: SelectOption[];
  rangeDefault: RangeSliderValue;
  shareFees: boolean;
  commonCurrencies: SelectOption[];
}
export default class AboutPractice extends React.Component<AboutPracticeProps, AboutPracticeState> {
  private autocomplete: any;

  private autocompleteListener: any;

  constructor(props: AboutPracticeProps) {
    super(props);
    this.state = {
      insurance: insuranceList.map((insurance: any) => {
        const opt = {} as SelectOption;
        opt.label = insurance;
        opt.value = insurance;
        return opt;
      }),
      paymentOptions: paymentList.map((payment: any) => {
        const opt = {} as SelectOption;
        opt.label = payment;
        opt.value = payment;
        return opt;
      }),
      population: populationList.map((pop: any) => {
        const opt = {} as SelectOption;
        opt.label = pop;
        opt.value = pop;
        return opt;
      }),
      services: serviceList.map((service: any) => {
        const opt = {} as SelectOption;
        opt.label = service;
        opt.value = service;
        return opt;
      }),
      specialties: specialtyList.map((specialty: any) => {
        const opt = {} as SelectOption;
        opt.label = specialty;
        opt.value = specialty;
        return opt;
      }),
      substance: substanceList.map((substance: string) => {
        const opt = {} as SelectOption;
        opt.label = substance;
        opt.value = substance;
        return opt;
      }),
      commonCurrencies: commonCurrencies.map((currency: string) => {
        return {
          value: currency,
          label: currency,
        } as SelectOption;
      }),
      rangeDefault: {
        min: 50,
        max: 150,
      },
      shareFees: !!this.props.values.fee,
    };
    this.autocomplete = null;
    this.handleFeeSwitch = this.handleFeeSwitch.bind(this);
  }

  public handleFeeSwitch(state: boolean) {
    if (!state) {
      this.props.values.fee = null;
    } else {
      this.props.values.fee = {
        min: this.state.rangeDefault.min,
        max: this.state.rangeDefault.max,
        currency: this.state.commonCurrencies[0].value,
      } as iFee;
    }
    this.setState({
      shareFees: state,
    });
  }

  public componentWillUnmount() {
    if (this.autocompleteListener) {
      this.autocompleteListener.remove();
    }
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3 date" id="datetimepicker">
          <Label for="practiceYears">When was your practice founded?</Label>
          <br />
          <FormikDatetime
            placeholder="Practice founded"
            timeFormat={false}
            name="founded"
            defaultValue={this.props.values.founded}
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="addressTT">
            Your city, state, country are required. Street addresses are optional and will appear on your profile
            (public facing).
          </UncontrolledTooltip>
          <Label for="locations">Practice Addresses:</Label>&nbsp;&nbsp;
          <span id="addressTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiAddress
            max={5}
            values={this.props.values.locations}
            name="locations"
            placeHolder="Start typing city then state"
            validationFunc={(val) => {
              if (val.city && val.region && val.country) {
                return {
                  valid: true,
                } as ValidationFuncResult;
              }
              return {
                valid: false,
                err: "You must provide city, state and country",
              } as ValidationFuncResult;
            }}
          />
          <ErrorMessage name="locations" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="online">Do you offer online Sessions?</Label>&nbsp;&nbsp;
          <FormikSwitch name="online" onText="Yes" offText="No" />
          <br />
          <ErrorMessage name="online" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="inPerson">Do you offer In-Person Sessions?</Label>&nbsp;&nbsp;
          <FormikSwitch name="inPerson" onText="Yes" offText="No" />
          <br />
          <ErrorMessage name="inPerson" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="acceptingTT">
            If 'no' is selected, the contact form (emails) on your profile will be disabled.
          </UncontrolledTooltip>
          <Label for="acceptingClients">Are you currently accepting clients?</Label>&nbsp;
          <span id="acceptingTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          &nbsp;&nbsp;
          <FormikSwitch name="acceptingClients" onText="Yes" offText="No" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="slidingScale">Is your fee sliding scale?</Label>&nbsp;&nbsp;
          <FormikSwitch name="slidingScale" onText="Yes" offText="No" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="slidingScale">Do you want to publish your fee range?</Label>&nbsp;&nbsp;
          <Switch
            defaultValue={this.state.shareFees}
            offColor="primary"
            offText="No"
            onColor="primary"
            onText="Yes"
            onChange={(state) => {
              this.handleFeeSwitch(state.state.value);
            }}
          />
        </FormGroup>
        {this.state.shareFees && (
          <FormGroup className="mb-3">
            <Label for="fee">Fee Range:</Label>
            <br />
            <FormikMoneyRangeSlider
              currencyValue={this.props.values.fee ? this.props.values.fee.currency : null}
              currencyOptions={this.state.commonCurrencies}
              value={this.props.values.fee ? this.props.values.fee : this.state.rangeDefault}
              name="fee"
              min={0}
              max={1000}
            />
          </FormGroup>
        )}
        <FormGroup className="mb-3">
          <Label for="payment">Payment Options:</Label>
          <br />
          <FormikMultiSelect options={this.state.paymentOptions} value={this.props.values.payment} name="payment" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="insurance">Insurance:</Label>
          <br />
          <FormikMultiCreateSelect
            options={this.state.insurance}
            value={this.props.values.insurance}
            name="insurance"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="specialtiesTT">
            Specialties refer to patient issues that your practice specializes in. Select from list.
          </UncontrolledTooltip>
          <Label for="specialties">Specialties:</Label>&nbsp;
          <span id="specialtiesTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiSelect
            options={this.state.specialties}
            value={this.props.values.specialties}
            name="specialties"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="servicesTT">
            Services refer to services your practice offers. Choose from the list or type new items.
          </UncontrolledTooltip>
          <Label for="services">Services Offered:</Label>&nbsp;
          <span id="servicesTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiCreateSelect
            options={this.state.services}
            placeholder="Select your service-offered or type to enter"
            value={this.props.values.services}
            name="services"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="servicesTT">
            Substance refer to substances your practice offers.
          </UncontrolledTooltip>
          <Label for="services">Substance Offered:</Label>&nbsp;
          <span id="servicesTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiSelect options={this.state.substance} value={this.props.values.substance} name="substance" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="population">Patient Population:</Label>
          <br />
          <FormikMultiSelect options={this.state.population} value={this.props.values.population} name="population" />
        </FormGroup>
      </>
    );
  }
}
